/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Reseller_Pricing_UnpricedInputs */

const id_reseller_pricing_unpriced = /** @type {(inputs: Reseller_Pricing_UnpricedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Isi harga jual registrasi ${i?.tld} sebelum mengaktifkannya.`)
};

const en_reseller_pricing_unpriced = /** @type {(inputs: Reseller_Pricing_UnpricedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Give ${i?.tld} a registration price before putting it on sale.`)
};

/**
* | output |
* | --- |
* | "Give {tld} a registration price before putting it on sale." |
*
* @param {Reseller_Pricing_UnpricedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_unpriced = /** @type {((inputs: Reseller_Pricing_UnpricedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_UnpricedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_unpriced(inputs)
	return id_reseller_pricing_unpriced(inputs)
});